module.exports = __webpack_public_path__ + "static/media/hkdirWhiteLogo.c76f49f9.svg";